var React = require('react');

function IconChevronRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"stroke":"currentColor","strokeWidth":"2","d":"M9 4l8 8-8 8","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round"}));
}

IconChevronRight.defaultProps = {"width":"24","height":"24"};

module.exports = IconChevronRight;

IconChevronRight.default = IconChevronRight;
